module.exports = __webpack_public_path__ + "img/kui_AAAI.bb668668.png";